import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { LogOut } from "Shared/appIcons";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type Props = {
	userLogin: string;
	userInitials: string;
	onSignOut: () => void;
};

export const UserMenu = ({ userLogin, userInitials, onSignOut }: Props) => {
	const { t } = useResource();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				className="hover:bg-muted flex cursor-pointer items-center gap-2 rounded-md py-1 pr-1 pl-2 outline-none"
				title={userLogin}
			>
				<div className="bg-primary-light text-primary text-tiny flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full font-semibold">
					{userInitials}
				</div>
				<span className="text-tiny text-foreground hidden max-w-[160px] truncate font-medium xl:block">
					{userLogin}
				</span>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" sideOffset={6} className="min-w-44">
				<DropdownMenuGroup>
					<DropdownMenuLabel className="text-muted-foreground truncate">
						{userLogin}
					</DropdownMenuLabel>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={onSignOut}>
					<LogOut className="h-4 w-4" />
					{t(Resources.Common.SignOut)}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
